
<style scoped lang='stylus'>
@import '../../assets/style/vars.styl'
.product-news-list-page
  background-color white
  height 100vh
  overflow-y auto
  .list-container
    padding 24px 32px
    box-sizing border-box
  .news-item
    margin-bottom 80px
  .news-name
    color: #1d1d1d
    font-size: 34px
    margin-top: 20px
    font-weight: 600
    margin-bottom: 20px
  .news-detail
    color: #999
    font-size: 28px
    margin-bottom: 40px
  .empty
    padding-top 300px
    text-align center
    color #888
    font-size 24px
</style>
<template>
  <div class="product-news-list-page">
    <div v-if="newsList && newsList.length" class="list-container">
      <div class="news-item" v-for="(item, index) in newsList" :key="index">
        <h3 class="news-name">{{item.name}}</h3>
        <p class="news-detail">{{item.detail}}</p>
      </div>
    </div>
    <div v-else class="empty">
      暂无数据
    </div>
  </div>
</template>
<script>
import { fetchNewDegreeInfoList } from '../../common/api/some'
import { getLocationQuery } from '../../common/utils'
export default {
  name: 'ProductNewsListPage',
  props: {
    // name: { type: Array, default: () => [] }
  },
  data: function () {
    return {
      // isLoading: false,
      newsList: [
        // { newsID: '1', name: '12', detail: '123123123af 萨法搜到额为人情味额 去玩儿清热  去玩儿任务清热' },
        // { newsID: '12', name: '12', detail: '123123123af 萨法搜到额为人情味额 去玩儿清热  去玩儿任务清热' },
        // { newsID: '13', name: '12', detail: '123123123af 萨法搜到额为人情味额 去玩儿清热  去玩儿任务清热' },
        // { newsID: '14', name: '12', detail: '123123123af 萨法搜到额为人情味额 去玩儿清热  去玩儿任务清热' },
      ]
    }
  },
  computed: {},
  created: function () {
    const querys = getLocationQuery() || {}
    const { kindID = '' } = querys
    this.kindID = kindID
    this.getData(this.kindID)
  },
  mounted: function () {},
  // beforeDestroy: function() {},
  watch: {},
  methods: {
    async getData (kindID) {
      // this.isLoading = true
      try {
        const res = await fetchNewDegreeInfoList({ kindID })
        // const res = await test({ pageNum: 2, pageSize: 2 })
        // this.isLoading = false
        if (res && res.errorCode === 0) {
          this.newsList = res.news || []
        }
      } catch (e) {
        // this.isLoading = false
      }
    }
  }
}
</script>
